import moment from 'jalali-moment'
import React from 'react'
import { ConvertJalaliDate } from 'utilities/helper/digitToMonth'
import { MoneyPoolTransactionTypes } from 'utilities/helper/moneyPools'
import deposit_icon from 'assets/images/rectangle/ic_deposit.svg'
import endurance_icon from 'assets/images/rectangle/ic_endurance.svg'
interface IItemProps {
    item: ICashinCashoutFinancial
}
// Android renders this list with the SAME item_moneypool_transaction.xml
// as the fund's transactions tab (force-LTR): arrow + colored amount on
// the LEFT, name right-aligned on the RIGHT, type below the name,
// date|time bottom-right.
export default function Item({ item }: IItemProps) {
    const isCashin = item.type.substring(0, 2) === 'cn'
    return (
        <div
            className="mx-4 my-1.5 rounded-[10px] border border-stroke bg-white p-3"
            dir="ltr"
        >
            {/* icon + amount (left) and member name (right) */}
            <div className="flex flex-row items-baseline">
                <img
                    className="h-4 w-4 self-center"
                    src={isCashin ? deposit_icon : endurance_icon}
                    alt=""
                />
                <p
                    className={`ml-2 shrink-0 font-bold text-base ${
                        isCashin ? 'text-success-1' : 'text-danger'
                    }`}
                >
                    {item.amount && item.amount.toLocaleString()} تومان
                </p>
                <p className="ml-2 flex-1 text-right font-bold text-base text-[#565F6B]">
                    {item.poolship_name}
                </p>
            </div>

            {/* type (right) */}
            <p className="mt-4 text-right text-sm text-text-secondary">
                {MoneyPoolTransactionTypes[item.type]}
            </p>

            {/* date/time (right) */}
            <p className="mt-4 text-right text-xs text-text-secondary" dir="rtl">
                {(() => {
                    const date =
                        item?.jalali_time &&
                        ConvertJalaliDate(item.jalali_time)
                    const parsed = moment.from(
                        item.jalali_time,
                        'fa',
                        'jYYYY-jM-jD HH:mm:ss'
                    )
                    const time = parsed.isValid()
                        ? parsed.format('HH:mm:ss')
                        : ''
                    return !time || time === '00:00:00'
                        ? date
                        : `${date} | ${time}`
                })()}
            </p>
        </div>
    )
}
